<template>
  <PagePortal title="Cezma - log in or sign up" description="" class="grid place-items-center relative" :disableIndexing="true">
    <section class="my-20">
      <Register v-if="route.params.type == 'new'" />
      <ForgotPassword v-if="route.params.type == 'forgot-password'" />
      <ResetPassword v-if="route.params.type == 'reset-password'" />
      <Login v-if="isEmpty(route.params) || route.params.type == ''" />
    </section>
    <img src="@/assets/auth/background.svg" alt class="absolute z-[-1] bottom-0" />
  </PagePortal>
</template>

<script>
import PagePortal from '@/components/generic/PagePortal.vue';
import { Register, Login, ForgotPassword, ResetPassword } from '@/components';
import { isEmpty } from '@/helpers';

export default {
  setup() {
    definePageMeta({
      layout: 'user',
    });
    const route = useRoute();
    const router = useRouter();
    return {
      route,
      router,
    };
  },
  components: {
    PagePortal,
    Register,
    Login,
    ForgotPassword,
    ResetPassword,
  },
  data() {
    return {};
  },
  watch: {},
  methods: {
    isEmpty,
  },
  mounted() {
    if (!process.client) {
      return;
    }
    const isUserLogged = this.useLocalStorage({ type: 'get', key: 'user' })?.token; //check if token exist
    isUserLogged && this.route.params.type != 'reset-password' && this.router.replace('/');
  },
};
</script>

<style></style>
